/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "../../../utils/bindUrl";
import {
  IApprovalFlowExecutionStep,
  IResponseListApprovalFlowExecutionSteps,
  IResponseShowApprovalFlowExecutionStep,
} from "../../../interfaces/approvalFlowExecutionStep";
import {
  IApprovalFlowExecution,
  IResponseListApprovalFlowExecutions,
  IResponseShowApprovalFlowExecution,
} from "../../../interfaces/approvalFlowExecutions";
import {
  IApprovalFlowExecutionFile,
  IResponseListApprovalFlowExecutionFile,
  IResponseShowApprovalFlowExecutionFile,
} from "../../../interfaces/approvalFlowExecutionFile";
import { IResponseListApprovalFlowExecutionInteractions } from "../../../interfaces/approvalFlowExecutionStepLinks copy";
import { IResponseListApprovalFlowExecutionStepLinks } from "../../../interfaces/approvalFlowExecutionStepLinks";

const BASE_EXECUTIONS = "/approval_flow_executions";
const BASE_STEPS = "/approval_flow_execution_steps";
const BASE_INTERACTIONS = "/approval_flow_execution_interactions";
const BASE_FILES = "/approval_flow_execution_files";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

/* ===== Executions ===== */
export async function listApprovalFlowExecutions({
  filter,
  includes,
  page,
  limit,
  sort,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlowExecutions>(BASE_EXECUTIONS, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showApprovalFlowExecution({
  id,
  includes,
  select,
}: {
  id: string | number;
  includes?: string[];
  select?: string[];
}) {
  const url = buildUrl(`${BASE_EXECUTIONS}/{id}`, { id });
  const { data } = await api.get<IResponseShowApprovalFlowExecution>(url, {
    params: { includes, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createApprovalFlowExecution({
  approvalFlowExecution,
}: {
  approvalFlowExecution: IApprovalFlowExecution;
}) {
  const { data } = await api.post<IResponseShowApprovalFlowExecution>(BASE_EXECUTIONS, {
    approvalFlowExecution,
  });
  return data;
}

export async function updateApprovalFlowExecution({
  id,
  approvalFlowExecution,
}: {
  id: string | number;
  approvalFlowExecution: IApprovalFlowExecution;
}) {
  const url = buildUrl(`${BASE_EXECUTIONS}/{id}`, { id });
  const { data } = await api.put<IResponseShowApprovalFlowExecution>(url, {
    approvalFlowExecution,
  });
  return data;
}

/* ===== Steps ===== */
export async function listApprovalFlowExecutionSteps({
  filter,
  includes,
  page,
  limit,
  sort,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlowExecutionSteps>(BASE_STEPS, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showApprovalFlowExecutionStep({
  id,
  includes,
  select,
}: {
  id: string | number;
  includes?: string[];
  select?: string[];
}) {
  const url = buildUrl(`${BASE_STEPS}/{id}`, { id });
  const { data } = await api.get<IResponseShowApprovalFlowExecutionStep>(url, {
    params: { includes, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createApprovalFlowExecutionStep({
  approvalFlowExecutionStep,
}: {
  approvalFlowExecutionStep: IApprovalFlowExecutionStep;
}) {
  const { data } = await api.post<IResponseShowApprovalFlowExecutionStep>(BASE_STEPS, {
    approvalFlowExecutionStep,
  });
  return data;
}

export async function updateApprovalFlowExecutionStep({
  id,
  approvalFlowExecutionStep,
}: {
  id: string | number;
  approvalFlowExecutionStep: IApprovalFlowExecutionStep;
}) {
  const url = buildUrl(`${BASE_STEPS}/{id}`, { id });
  const { data } = await api.put<IResponseShowApprovalFlowExecutionStep>(url, {
    approvalFlowExecutionStep,
  });
  return data;
}

/* ===== Step Links (nomes preservados) ===== */
export async function ShowNextApprovalFlowExecutionStepLink({
  idStepExecution,
}: {
  idStepExecution: string | number;
}) {
  const url = buildUrl(`${BASE_STEPS}/{idStepExecution}/links`, { idStepExecution });
  const { data } = await api.get<IResponseListApprovalFlowExecutionStepLinks>(url);
  return data;
}

export async function NextApprovalFlowExecutionStepLink({
  idApprovalFlowExecution,
  links,
}: {
  idApprovalFlowExecution: string | number;
  links: { idApprovalFlowStepLink: number }[];
}) {
  const url = buildUrl(`${BASE_EXECUTIONS}/{idApprovalFlowExecution}/next`, {
    idApprovalFlowExecution,
  });
  const { data } = await api.post<IResponseListApprovalFlowExecutionStepLinks>(url, {
    links,
  });
  return data;
}

/* ===== Interactions ===== */
export async function listApprovalFlowExecutionInteractions({
  filter,
  includes,
  page,
  limit,
  select,
  sort,
}: IListParams) {
  const { data } =
    await api.get<IResponseListApprovalFlowExecutionInteractions>(BASE_INTERACTIONS, {
      params: { filter, includes, page, limit, select, sort },
      paramsSerializer: (params) => serialize(params),
    });
  return data;
}

/* ===== Files ===== */
export async function createApprovalFlowExecutionFile({
  approvalFlowExecutionFile,
}: {
  approvalFlowExecutionFile: IApprovalFlowExecutionFile;
}) {
  const { data } = await api.post<IResponseShowApprovalFlowExecutionFile>(BASE_FILES, {
    approvalFlowExecutionFile,
  });
  return data;
}

export async function deleteApprovalFlowExecutionFile({
  id,
}: {
  id: string | number;
}) {
  const url = buildUrl(`${BASE_FILES}/{id}`, { id });
  const { data } = await api.delete<IResponseShowApprovalFlowExecutionFile>(url);
  return data;
}

export async function listApprovalFlowExecutionFile({
  filter,
  includes,
  page,
  limit,
  sort,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlowExecutionFile>(BASE_FILES, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}
